import React, { useState } from 'react';
import ModalComponent from '../../../../../../helper_components/ModalComponent';
import ElectronicSignatureProcessProvider, {
  useElectronicSignatureProcessContext,
} from '../../../../../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/context/ElectronicSignatureProcessContext';
import BodyModal from './components/bodyModal/BodyModal';
import FooterModal from './components/footerModal/FooterModal';
import { useFilesPendingSignatureContext } from '../../context/FilesPendingSignatureContext';
import useElectronicSignatureModalState from './hooks/useElectronicSignatureModalState';
import SignatureConfirmationModal from './components/signatureConfirmationModal/SignatureConfirmationModal';
import NotifyEmailModal from '../../../../modals/NotifyEmailModal';
import { holidayDates, isWeekday } from '../../../CustomInputDate/CustomDateRules';
import { useEffect } from 'react';

const ElectronicSignatureModal = ({
  isShowing = false,
  onCloseModalClick = () => {},
  handleOpenTransfer = () => {},
  getDocumentsByExpedient = () => {},
  setDocumentToAssign = () => {},
}) => {
  if (!isShowing) {
    return <></>;
  }

  const { documentParameters } = useFilesPendingSignatureContext();

  return (
    <ElectronicSignatureProcessProvider
      key={documentParameters.documentId}
      isOnlyOneSignaturePerUserActivated={true}
    >
      <ElectronicSignatureModalComponent
        onCloseModalClick={onCloseModalClick}
        handleOpenTransfer={handleOpenTransfer}
        getDocumentsByExpedient={getDocumentsByExpedient}
        setDocumentToAssign={setDocumentToAssign}
      />
    </ElectronicSignatureProcessProvider>
  );
};

const ElectronicSignatureModalComponent = ({
  onCloseModalClick = () => {},
  handleOpenTransfer = () => {},
  getDocumentsByExpedient = () => {},
  setDocumentToAssign = () => {},
}) => {
  const {
    documentParameters,
    setDocumentParameters,
    expedientId,
    isNotifyEmailModalShowing,
    handleHideNotifyEmailModal,
  } = useFilesPendingSignatureContext();
  const {
    handleSaveSignatureAndTransfer,
    isElectronicSignatureTableShowing,
    handleSendNotifyEmailButtonClick,
    handleSignDocumentClick,
    isOnlyOneSignaturePerUserActivated,
    handleCloseSignatureConfirmationModal,
    handleOpenSignatureConfirmationModal,
    isSignatureConfirmationModalShowing,
  } = useElectronicSignatureModalState({
    onCloseModalClick,
    handleOpenTransfer,
    getDocumentsByExpedient,
    setDocumentToAssign,
  });

  const { electronicSignaturesRecentlyAddedList } = useElectronicSignatureProcessContext();
  const canPerformAnAction = Boolean(electronicSignaturesRecentlyAddedList.length);
  const [dateIsAccepted, setDateIsAccepted] = useState(true);
  const [datePickerIsEnabled, setDatePickerIsEnabled] = useState(false);
  const [holiday, setHoliday] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    (async () => {
      setHoliday(await holidayDates());
    })();
  }, []);

  const bodyModal = (
    <BodyModal
      documentParameters={documentParameters}
      setDocumentParameters={setDocumentParameters}
      dateIsAccepted={dateIsAccepted}
      setDateIsAccepted={setDateIsAccepted}
      datePickerIsEnabled={datePickerIsEnabled}
      holiday={holiday}
      errors={errors}
      setErrors={setErrors}
      isOnlyOneSignaturePerUserActivated={isOnlyOneSignaturePerUserActivated}
      isElectronicSignatureTableShowing={isElectronicSignatureTableShowing}
    />
  );

  const footerModal = (
    <FooterModal
      isTransferExpedinetButtonDisabled={!canPerformAnAction}
      isSignDocumentButtonDisabled={!canPerformAnAction}
      onTransferExpedinetClick={handleSaveSignatureAndTransfer}
      dateIsAccepted={dateIsAccepted}
      onSignDocumentClick={async () => {
        if (dateIsAccepted && documentParameters['ifexcerpt']) {
          const publication_date = new Date(documentParameters['publish_date']);
          const holidays = await holidayDates();

          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const publicationDateOnly = new Date(publication_date);
          publicationDateOnly.setHours(0, 0, 0, 0);
          const isPublicationDateOld = publicationDateOnly.getTime() < today.getTime();
          const isPublicationDateValid =
            isWeekday(publication_date) &&
            !holidays.some((date) => publication_date.getTime() === date.getTime()) &&
            !isPublicationDateOld;

          if (
            !isPublicationDateValid &&
            documentParameters &&
            documentParameters.expedient.kind_judgment_id !== 59 &&
            documentParameters.expedient.matter !== 'laboral'
          ) {
            setDocumentParameters({
              ...documentParameters,
              publish_date: '',
            });
            setDatePickerIsEnabled(true);
            setDateIsAccepted(false);
            setErrors({
              ...errors,
              publish_date: [
                'La fecha de publicación debe ser un día hábil y no puede ser anterior a la fecha actual.',
              ],
            });
            setHoliday([...holidays, publication_date]);
            return;
          }
          handleOpenSignatureConfirmationModal();
          return;
        }

        handleOpenSignatureConfirmationModal();
      }}
    />
  );

  return (
    <>
      <ModalComponent
        header="Firmar Documento"
        body={bodyModal}
        footer={footerModal}
        show={true}
        canClose={true}
        onHide={onCloseModalClick}
        scroll={true}
        dialogClassName="electronic-signature-modal"
      />

      <SignatureConfirmationModal
        onConfirmClick={handleSignDocumentClick}
        onCloseModalClick={handleCloseSignatureConfirmationModal}
        isModalShowing={isSignatureConfirmationModalShowing}
      />

      {isNotifyEmailModalShowing && (
        <NotifyEmailModal
          expedientId={expedientId || documentParameters.expedient_id}
          showModal={isNotifyEmailModalShowing}
          handleOnCancel={handleHideNotifyEmailModal}
          onAcceptClick={handleSendNotifyEmailButtonClick}
        />
      )}
    </>
  );
};

export default ElectronicSignatureModal;
